import { render, staticRenderFns } from "./spin-button.vue?vue&type=template&id=b639c8c6&"
import script from "./spin-button.vue?vue&type=script&lang=js&"
export * from "./spin-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports